import React from 'react';
import { X, Minus } from 'lucide-react';
import type { WidgetConfig, WidgetMode } from '../types';

interface ChatHeaderProps {
  config: WidgetConfig;
  widgetMode: WidgetMode;
  onClose: () => void;
  onMinimize: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ config, widgetMode, onClose, onMinimize }) => {
  const { branding } = config;

  return (
    <div
      className="flex items-center justify-between px-4 py-3 shrink-0"
      style={{
        backgroundColor: branding.primary_color,
        color: branding.text_color,
        fontFamily: branding.font_family || 'system-ui, sans-serif',
      }}
    >
      <div className="flex items-center gap-3 min-w-0">
        {branding.logo_url && (
          <img
            src={branding.logo_url}
            alt=""
            className="w-8 h-8 rounded-full object-cover shrink-0"
          />
        )}
        <span className="font-semibold text-sm truncate">
          {branding.header_title}
        </span>
      </div>
      {widgetMode === 'embedded' ? (
        <div className="flex items-center gap-1 shrink-0">
          <button
            onClick={onMinimize}
            className="p-1.5 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Minimize chat"
          >
            <Minus size={16} />
          </button>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Close chat"
          >
            <X size={16} />
          </button>
        </div>
      ) : (
        <span className="text-[10px] opacity-75 shrink-0">Powered by QBrains</span>
      )}
    </div>
  );
};
